export default __webpack_public_path__ + "static/media/330_dummy2016-modelportfolio01-de-mobile.3d97e44e.png";